<p-toast position="top-right"></p-toast>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <customer-info *ngIf="isVisibleCustomerInfo"
                   [isVisibleCustomerInfo]="isVisibleCustomerInfo"
                   [_customerId]="userId"
                   [isBanned]="isBanned"
                   [showEditFields]="false"
                   [showLogsRequest]="true"
                   (changedVisibleCustomerInfoEmit)="changedVisibleCustomerInfoEmit($event)"
                   (suspendSuccessEmit)="onCustomerSuspendSuccess()"
                   (banSuccessEmit)="onCustomerBanSuccess()"
                   (liftSuspensionSuccessEmit)="onCustomerLiftSuspensionSuccess()"
                   (liftBanSuccessEmit)="onCustomerLiftBanSuccess()"></customer-info>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <div class="onboarding-head">
            <div class="onboarding-head-fleft">
            </div>
            <div class="flex flex-row onboarding-head-right">
            </div>
        </div>

        <p-table #ridersGrid
                 [columns]="cols"
                 [value]="xpressUsers"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 [loading]="loading"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [showFirstLastIcon]="false"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(100vh - 130px)'}">
            <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <div class="onboarding-head-title">
                   {{tableName}}
                </div>
                <span class="flex">
                    <button pButton pRipple type="button" label="Edit Table" class="p-button"
                            style="padding: 10px 20px 10px 20px; "></button>

                    <div class="ml-4 mt-1">
                        <column-selector #columnSelector
                             [defaultColumns]="defaultCols"
                             (selectedColumnsChange)="onSelectedColumnsChange($event)"
                             [tableName]="tableName"
                             [(selectedColumns)]="cols">
                        </column-selector>
                    </div>
                </span>
            </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        <div class="sortable-header">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" class="onboarding-column-sorticon"></p-sortIcon>
                        </div>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let item of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{item.placeholder}}" [(ngModel)]="userHeaderSearch[item.model]"
                                       (input)="handleHeaderFilterChange()" />
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{item.placeholder}}" [(ngModel)]="userHeaderSearch[item.model]"
                                               (ngModelChange)="handleHeaderFilterChange()"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="item.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" [(ngModel)]="userHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange()"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="userHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange()"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="userHeaderSearch[item.model]"
                                            [showIcon]="true"
                                            placeholder="{{item.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="handleHeaderFilterChange()" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
                <tr [pSelectableRow]="user" class="cursor-pointer" (click)="handlePopupLinkClick(user, false)">
                    <td class="ui-resizable-column" *ngFor="let item of cols">
                        <ng-container [ngSwitch]="item.field">
                            <ng-container *ngSwitchCase="'StatusText'">
                                <div class="user-disciplinaty-status-col m-auto"
                                      [style.color]="user.StatusColor"
                                      [style.background-color]="user.StatusBackColor">
                                    {{user.StatusText}}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <span class="ui-resizable-column">
                                    {{user[item.field]}}
                                </span>
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr class="empty-state-row">
                    <td [attr.colspan]="cols.length" class="text-center">
                        <div class="flex flex-column align-items-center justify-content-center">
                            <img src="/XpressApp/assets/images/EmptyStateIcon.png" alt="No Users Found" style="width: 120px; height: 120px; object-fit: contain;" />
                            <p class="text-color-secondary font-semibold text-lg mt-3 mb-0">No Users Found.</p>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="xpressUsers.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + xpressUsers.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
